var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nr_container_content catalog_page__filter mb-160 " },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: " wow fadeUp",
          class: _vm.emptyfilter ? "row--empty" : "row ",
        },
        [
          _c("div", { class: _vm.emptyfilter ? "d-none" : " " }, [
            _c(
              "div",
              { staticClass: "catalog_page__filter_items" },
              _vm._l(_vm.category_lists, function (list, name, indexCat) {
                return _c("div", { staticClass: "filter_item mb-6 " }, [
                  _c("div", { staticClass: "filter_item__title" }, [
                    _vm._v(_vm._s(list)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "filter_item__boxes",
                      class: _vm.showMore[name]
                        ? "filter_item--expanded"
                        : "filter_item--collapsed",
                    },
                    [
                      _c(
                        "transition-group",
                        {
                          staticClass: "filter_item__inner",
                          attrs: { name: "fade-list", tag: "div" },
                        },
                        _vm._l(
                          _vm.visibleCheckboxes[name],
                          function (checkbox, index) {
                            return _c(
                              "div",
                              {
                                key: checkbox.value,
                                staticClass: "filter_item__sel d-flex",
                              },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    value: checkbox.value,
                                    color: "red darken-3",
                                    "hide-details": "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.change_filter(checkbox, index)
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c("div", [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(checkbox.label) +
                                                  "\n                                            "
                                              ),
                                              checkbox.prompt.length > 0
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "filter_item__info ",
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "d-inline-block",
                                                        attrs: {
                                                          src: "/local/templates/international/img/fi_info.svg",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            checkbox.prompt
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.filter_type_checkbox_checked,
                                    callback: function ($$v) {
                                      _vm.filter_type_checkbox_checked = $$v
                                    },
                                    expression: "filter_type_checkbox_checked",
                                  },
                                }),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.numberBoxes(name)
                    ? _c(
                        "button",
                        {
                          staticClass: "show-more_btn",
                          on: {
                            click: function ($event) {
                              return _vm.toggleShowMore(name)
                            },
                          },
                        },
                        [
                          !_vm.showMore[name]
                            ? _c("span", { staticClass: "btn-text-fade" }, [
                                _vm._v(
                                  "Показать еще\n                            "
                                ),
                                _c(
                                  "svg",
                                  {
                                    staticClass: "show-more_btn--svg",
                                    attrs: {
                                      width: "13",
                                      height: "6",
                                      viewBox: "0 0 13 6",
                                      fill: "none",
                                      xmlns: "http://w3.org",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M0.5 0L6.5 6L12.5 0L0.5 0Z",
                                        fill: "#FA4237",
                                      },
                                    }),
                                  ]
                                ),
                              ])
                            : _c("span", { staticClass: "btn-text-fade" }, [
                                _vm._v("Скрыть\n                            "),
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "13",
                                      height: "6",
                                      viewBox: "0 0 13 6",
                                      fill: "none",
                                      xmlns: "http://w3.org",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          "clip-path": "url(#clip0_2489_5811)",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M12.5 6L6.5 -5.24537e-07L0.5 6L12.5 6Z",
                                            fill: "#FA4237",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("defs", [
                                      _c(
                                        "clipPath",
                                        { attrs: { id: "clip0_2489_5811" } },
                                        [
                                          _c("rect", {
                                            attrs: {
                                              width: "13",
                                              height: "6",
                                              fill: "white",
                                              transform:
                                                "translate(13 6) rotate(-180)",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                        ]
                      )
                    : _vm._e(),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", {}, [
            _c("div", { staticClass: "catalog_page__filter_contents" }, [
              Object.keys(_vm.items_checked).length <= 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "row filter_contents__item_row position-relative",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "noResults  w-100 text-center" },
                        [
                          _c("div", { staticClass: "noResults__title" }, [
                            _vm._v("Нет результатов"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn_red reset_filter",
                              on: { click: _vm.filterReset },
                            },
                            [_vm._v("Сбросить фильтр")]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: " filter_contents__item_row position-relative" },
                _vm._l(_vm.items_checked, function (item, index) {
                  return _c(
                    "div",
                    {
                      staticClass:
                        "filter_contents__item mb-0 market  position-relative",
                    },
                    [
                      _c("div", { staticClass: "bar_item__content h-100" }, [
                        _c("div", { staticClass: "item_plain h-100" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex h-100 item_plain__content item_polls flex-column",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "market__img d-flex justify-content-center",
                                },
                                [_c("img", { attrs: { src: item.img } })]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 justify-content-between flex-column d-flex item_plain__descr",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "item_plain__title flex-grow-1",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(item.name) +
                                          "\n                                        "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("a", {
                        staticClass:
                          "w-100 position-absolute h-100 l-0 t-0 zi-1",
                        attrs: { href: item.url },
                      }),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "products__links d-none" }, [
      _c(
        "a",
        {
          staticClass: "d-block border-0 py-0 mt-4 color-dark",
          attrs: {
            href: "/upload/iblock/29d/x4vfk0jhi93gksid8bmtaoctvuoru9nq/KatalogNOVAROLL2021.pdf",
            download: "",
          },
        },
        [
          _c("img", {
            staticClass: "pr-3",
            attrs: { src: "/upload/pad_img.svg", alt: "" },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "text-decoration-underline" }, [
            _vm._v("Скачать каталог NOVAROLL Транспортная упаковка"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "d-block border-0 py-0 mt-4 color-dark",
          attrs: {
            href: "/upload/iblock/a50/h99vzn2amkito52um1qk0sdmogxqjdlp/catalog_unibob.pdf",
            target: "_blank",
          },
        },
        [
          _c("img", {
            staticClass: "pr-3",
            attrs: { src: "/upload/pad_img.svg", alt: "" },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "text-decoration-underline" }, [
            _vm._v("Каталог UNIBOB"),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }